import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import * as _ from "lodash";
import { ToolsService } from 'src/app/services/tools/tools.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
@Component({
  selector: 'app-alert-invalid-price-period',
  templateUrl: './alert-invalid-price-period.component.html',
  styleUrls: ['./alert-invalid-price-period.component.css']
})
export class AlertInvalidPricePeriodComponent implements OnInit {

  basket: any[] | any;

  changedPriceProds: any[];
  unavailableProds: any[];

  innerHeight: number = window.innerHeight;
  merchantClient: any = null;
  obserUser: any
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<AlertInvalidPricePeriodComponent>,
    private panierMan: PanierService,
    public tools: ToolsService,
    private clientMerchantApi: ClientMerchantsService,
    private authService: AuthService
  ) {


    this.changedPriceProds = data.errPeriod.changedPriceProds;
    this.unavailableProds = data.errPeriod.unavailableProds;
  }

  ngOnInit() {

    this.getClient();

  }
  ngOnDestroy(): void {

    if (this.obserUser) {
      this.obserUser.unsubscribe();
    }

  }

  /**
    * @description check si user connecté pour calcul si discount 
    */
  getClient() {



    this.obserUser = this.authService.getUser.subscribe((user: any) => {

      this.merchantClient = null;

      if (user) {


    
         let curr_id_merchant: any=this.tools.getStor("id_merchant");

        if (curr_id_merchant) {
          this.clientMerchantApi.getMerchantClient().subscribe((client: any) => {
            this.merchantClient = client;

            this.panierMan.getPanier.subscribe(basket => {

              this.basket = basket;

              if (this.changedPriceProds.length > 0 && this.tools.checkCurrentPage("endorder")) {
                this.changeBasketPrice();
              }
              else {
                let clone = _.cloneDeep(this.changedPriceProds);
                this.changedPriceProds = [];
                setTimeout(() => {
                  this.changedPriceProds = clone;
                }, 10);

              }

            }).unsubscribe();
          });
        }
      }
      else {
        this.panierMan.getPanier.subscribe(basket => {

          this.basket = basket;



          if (this.changedPriceProds.length > 0 && this.tools.checkCurrentPage("endorder")) {
            this.changeBasketPrice();
          }

        }).unsubscribe();
      }

    });
  }
  changeBasketPrice() {


    for (let i = 0; i < this.changedPriceProds.length; i++) {
      let changeBasketPriceProd = this.changedPriceProds[i];
    
      for (let j = 0; j < this.basket.length; j++) {
        let basketProd = this.basket[j];

        if (basketProd.id === changeBasketPriceProd.id) {

          basketProd.old_total_after_period = changeBasketPriceProd.price;
          basketProd.price = changeBasketPriceProd.new_price_period;
          basketProd.total_ttc = changeBasketPriceProd.new_price_period * basketProd.quantity;

         
        }

      }

    }

    setTimeout(() => {

      this.panierMan.setPanier(this.basket);
    });

  }

  removeProdBasket() {


    for (let i = 0; i < this.unavailableProds.length; i++) {
      let unavailableProd = this.unavailableProds[i];

      for (let j = 0; j < this.basket.length; j++) {
        let basketProd = this.basket[j];

        if (basketProd.id === unavailableProd.id) {
          this.basket.splice(j, 1);
          --j;
        }

      }

    }

    setTimeout(() => {

      this.panierMan.setPanier(this.basket);
    });

  }

  closeDial(flag?: boolean) {


    if (flag && this.unavailableProds.length > 0) {
      this.removeProdBasket();
    }

    if (flag && this.changedPriceProds.length > 0) {
      this.changeBasketPrice();
    }

    this.dialogRef.close(flag);
  }

}
